import React, { Component } from 'react';
import FacebookIcon from 'react-share/es/FacebookIcon'
import VKIcon from 'react-share/es/VKIcon'
import OKIcon from 'react-share/es/OKIcon'
import FacebookShareButton from 'react-share/es/FacebookShareButton'
import VKShareButton from 'react-share/es/VKShareButton'
import OKShareButton from 'react-share/es/OKShareButton'

import './share.css'
class Share extends Component {

  clickShare = (name) => {
    window.ga('send', 'event', 'link', 'click', 'Socnet share ' + name);
  }

  render() {
    return (
      <div className="share">
        <div className="like">
          <div className="like__hover">
            <span onClick={(e) => this.clickShare('VK')}><VKShareButton url={window.location.href}>
              <VKIcon iconBgStyle={{ fill: 'transparent' }}></VKIcon>
            </VKShareButton></span>
            <span onClick={(e) => this.clickShare('OK')}><OKShareButton url={window.location.href}>
              <OKIcon iconBgStyle={{ fill: 'transparent' }}></OKIcon>
            </OKShareButton></span>
            <span onClick={(e) => this.clickShare('FB')}><FacebookShareButton url={window.location.href}>
              <FacebookIcon iconBgStyle={{ fill: 'transparent' }}></FacebookIcon>
            </FacebookShareButton></span>
          </div>
        </div>


      </div>
    );
  }
}

export default Share;